import { useShortcutEvents } from 'dashboard/composables/useKeyboardShortcuts';
import { SHORTCUT_ACTIONS } from 'dashboard/components/widgets/modal/constants';

/**
 * 会话列表键盘导航：上一通 / 下一通会话。
 * @param {import('vue').Ref<HTMLElement>} listRef 会话列表容器
 */
export function useChatListKeyboardEvents(listRef) {
  /** 读取列表 DOM，定位当前激活会话索引 */
  const getKeyboardListenerParams = () => {
    const allConversations = listRef.value.querySelectorAll(
      'div.conversations-list div.conversation'
    );
    const activeConversation = listRef.value.querySelector(
      'div.conversations-list div.conversation.active'
    );
    const activeConversationIndex = [...allConversations].indexOf(
      activeConversation
    );
    const lastConversationIndex = allConversations.length - 1;
    return {
      allConversations,
      activeConversation,
      activeConversationIndex,
      lastConversationIndex,
    };
  };

  /**
   * 按方向切换会话；越界时落到首/末项。
   * @param {'previous'|'next'} direction
   */
  const handleConversationNavigation = direction => {
    const { allConversations, activeConversationIndex, lastConversationIndex } =
      getKeyboardListenerParams();

    const newIndex =
      direction === 'previous'
        ? activeConversationIndex - 1
        : activeConversationIndex + 1;

    if (
      allConversations.length > 0 &&
      newIndex >= 0 &&
      newIndex <= lastConversationIndex
    ) {
      allConversations[newIndex].click();
    } else if (allConversations.length > 0) {
      const fallbackIndex =
        direction === 'previous' ? 0 : lastConversationIndex;
      allConversations[fallbackIndex].click();
    }
  };

  useShortcutEvents({
    [SHORTCUT_ACTIONS.OPEN_PREVIOUS_CONVERSATION]: {
      action: () => handleConversationNavigation('previous'),
      allowOnFocusedInput: true,
    },
    [SHORTCUT_ACTIONS.OPEN_NEXT_CONVERSATION]: {
      action: () => handleConversationNavigation('next'),
      allowOnFocusedInput: true,
    },
  });
}
